/* eslint-disable react/destructuring-assignment,react/jsx-props-no-spreading */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Switch } from "react-router";
import { Spin } from "antd";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { fetchGetAgreementsByAccId } from "../../store/slices/agreements";
import { fetchAgrStatus, fetchProducts } from "../../store/slices/rtkDictionaries";
import RouteWithSubRoutes from "../../router/RouteWithSubRoutes";
import { useAppSelector } from "../..";
import { fetchBlockingTypes } from "../../store/slices/blocking";
import useBlockingMode from "../../lib/hooks/useBlockingMode";

function AccountAgreementsContainer(props) {
  const dispatch = useDispatch();
  const { accountId } = useParams();
  const { accountLoading } = useSelector((state) => state.accounts);
  const { agreementsLoading } = useSelector((state) => state.agreements);
  const { agrStatusLoading, productsLoading } = useSelector((state) => state.rtkDictionaries);
  const { blockingTypesLoading } = useAppSelector((state) => state.blocking);

  const isBlockingMode = useBlockingMode();

  useEffect(() => {
    if (checkIsLoaded(accountLoading)) {
      dispatch(fetchGetAgreementsByAccId({ accId: accountId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountLoading]);

  useEffect(() => {
    if (!checkIsLoaded(agrStatusLoading)) dispatch(fetchAgrStatus());
    if (!checkIsLoaded(productsLoading)) dispatch(fetchProducts());
    if (isBlockingMode && !checkIsLoaded(blockingTypesLoading)) dispatch(fetchBlockingTypes());
  }, []);

  return (
    <Spin spinning={checkIsLoading(agreementsLoading, agrStatusLoading)} className="spinner">
      <Switch>
        {props.routes.map((route) => (
          <RouteWithSubRoutes key={route.path} {...route} />
        ))}
      </Switch>
    </Spin>
  );
}

export default AccountAgreementsContainer;
